export interface ISidebarMenuItem {
    heading?: string;
    name?: string;
    icon?: string;
    translate?: string;
    path?: string;
    label?: {
        value: string | number;
        color: string;
    };
    submenu?: ISidebarMenu;
}

export type ISidebarMenu = Array<ISidebarMenuItem>;

const Menu: ISidebarMenu = [
    {
        heading: 'Main Navigation'
    },
    {
        name: 'Dashboard',
        path: '/dashboard'
    },
    {
        name: 'Organizations',
        path: '/',
        //icon: 'organizations-icon'
    },
    {
        name: 'Settings',
        path: '/settings',
    }
];

export default Menu;
